import { TableContainer, TableCell, TextField, Button, Box, styled } from "@mui/material";
import ordinaryColors from "themes/ordinaryColors";

export const StyledTableContainer = styled(TableContainer)(() => ({
  boxShadow: "none",
  border: `1px solid ${ordinaryColors.grey200}`,
  "& .MuiPaper-root": {
    boxShadow: "none",
  },
  "& .MuiTable-root": {
    "& .MuiTableHead-root .MuiTableRow-root .MuiTableCell-root": {
      borderTop: "none",
      borderBottom: "none",
    },
    "& .MuiTableBody-root .MuiTableRow-root:first-of-type .MuiTableCell-root": {
      borderTop: "none",
    },
    "& .MuiTableCell-root": {
      padding: "8px 16px",
    },
  },
}));

export const StyledColumnHeaderCell = styled(TableCell)(() => ({
  color: ordinaryColors.functionalBlack1000,
}));

export const StyledRowHeaderCell = styled(TableCell)(() => ({
  color: ordinaryColors.grey600,
}));

export const StyledTextField = styled(TextField)<{ error?: boolean }>(({ error }) => ({
  width: "100%",
  "& .MuiOutlinedInput-root": {
    background: error ? `rgba(211, 47, 47, 0.02)` : "inherit",
    borderRadius: 0,
    width: "100%",
    "& input[type=number]": {
      "-moz-appearance": "textfield",
    },
    "& input[type=number]::-webkit-outer-spin-button": {
      "-webkit-appearance": "none",
      margin: 0,
    },
    "& input[type=number]::-webkit-inner-spin-button": {
      "-webkit-appearance": "none",
      margin: 0,
    },
    "& fieldset": {
      borderRadius: 0,
      borderColor: error ? ordinaryColors.errorMain : undefined,
    },
    "&:hover fieldset": {
      borderRadius: 0,
      borderColor: error ? ordinaryColors.errorMain : undefined,
    },
    "&.Mui-focused fieldset": {
      borderRadius: 0,
      borderColor: error ? ordinaryColors.errorMain : undefined,
    },
  },
  "& .MuiOutlinedInput-input": {
    padding: "0.5rem 0.75rem",
    width: "100%",
  },
  "& .MuiFormHelperText-root.Mui-error": {
    display: "none",
  },
}));

export const StyledAddRangeButton = styled(Button)(() => ({
  color: ordinaryColors.grey900,
  fontFamily: "Roboto",
  fontSize: "15px",
  fontStyle: "normal",
  fontWeight: 500,
  lineHeight: "26px",
  letterSpacing: "0.46px",
  textTransform: "uppercase",
  borderRadius: 0,
  border: `1px solid ${ordinaryColors.grey200}`,
  backgroundColor: ordinaryColors.functionalWhite,
  "&:hover": {
    backgroundColor: ordinaryColors.functionalGreyBack,
  },
}));

/** Styled value cell with optional highlighting for historization */
export const StyledValueCell = styled(TableCell)<{ isHighlighted?: boolean }>(({ isHighlighted }) => ({
  backgroundColor: isHighlighted ? ordinaryColors.warning100 : "inherit",
  color: ordinaryColors.functionalBlack,
  padding: "8px 16px",
  textAlign: "center",
  border: isHighlighted ? `1px solid ${ordinaryColors.statusTagWarning}` : undefined,
}));

/** Display-only table container (no border, full width) */
export const StyledDisplayTableContainer = styled(TableContainer)(() => ({
  boxShadow: "none",
  width: "100%",
  "& .MuiPaper-root": {
    boxShadow: "none",
  },
  "& .MuiTable-root": {
    "& .MuiTableHead-root .MuiTableRow-root .MuiTableCell-root": {
      borderTop: "none",
      borderBottom: "none",
    },
    "& .MuiTableBody-root .MuiTableRow-root:first-of-type .MuiTableCell-root": {
      borderTop: "none",
    },
    "& .MuiTableCell-root": {
      padding: "8px 16px",
    },
  },
}));

/** Display-only column header with bold weight */
export const StyledDisplayColumnHeaderCell = styled(TableCell)(() => ({
  color: ordinaryColors.functionalBlack1000,
  fontWeight: 600,
}));

/** Display-only row header cell */
export const StyledDisplayRowHeaderCell = styled(TableCell)(() => ({
  color: ordinaryColors.functionalBlack1000,
  padding: "8px 16px",
}));

/** Access request container box */
export const AccessRequestBox = styled(Box)(({ theme }) => ({
  display: "flex",
  margin: "2% 5%",
  width: "90%",
  padding: "2rem",
  flexDirection: "column",
  alignItems: "center",
  gap: "1.0625rem",
  border: "0.0625rem solid #000",
  background: theme.palette.grey[100],
}));

/** Inner box for access request content */
export const AccessRequestInnerBox = styled(Box)(({ theme }) => ({
  width: "36.5rem",
  color: theme.palette.grey[600],
  textAlign: "center",
  lineHeight: "157%",
  letterSpacing: "0.00625rem",
  display: "flex",
  flexDirection: "column",
  gap: "0.625rem",
}));
